import { cn } from "@/utils/css";
import { getNumberWithCommas } from "@/utils/text";

export const CurrencyText = ({ num, className, round, emptyDash = false, canBeZero = false }) => {
    if (!num && !canBeZero) return emptyDash ? <span> - </span> : null;
    const localNum = getNumberWithCommas(num, round);

    return <span className={cn("text-2xl font-semibold text-cm-text-primary leading-[38px]", className)}>$ {localNum}</span>;
};
